import React from 'react';
import Modal from './Modal';
import Button from '../Button/Button';
import { colors } from '../../constants/colors';

/** Подтверждение необратимого действия: короткий вопрос и две кнопки. */
const ConfirmModal = ({
  isOpen,
  onClose,
  title,
  text,
  confirmText = 'Удалить',
  cancelText = 'Отмена',
  loading,
  onConfirm,
}) => (
  <Modal isOpen={isOpen} onRequestClose={onClose} title={title} width="480px" contentStyle={{ top: '22%', bottom: 'auto' }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <p style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 14, color: colors.blackPearl }}>{text}</p>
      <div style={{ display: 'flex', gap: 12 }}>
        <Button text={confirmText} fill onClick={onConfirm} disabled={loading} />
        <Button text={cancelText} onClick={onClose} disabled={loading} />
      </div>
    </div>
  </Modal>
);

export default ConfirmModal;
